import React from 'react';
import {useDispatch} from 'react-redux';
import Icon from '../../../../../../../../components/icon';
import {getSharingDetailsPopup} from '../../../../../../../../../actions/sharingDetailsActions';
import Button from "../../../../../../../../components/button";

function DirectoryParamButton ({title}) {

	const dispatch = useDispatch();

	const handleDirectoryOpt = () => {
		dispatch(getSharingDetailsPopup([true, "directorySync"]));
	};

	return (
		<Button className="btn-link" title={title} onClick={handleDirectoryOpt}>
			<div className="more-option-item__picto">
				<Icon name="cogs"/>
			</div>
			<div className="more-option-item__text">
				<span>{title}</span>
			</div>
		</Button>
	)
}

export default DirectoryParamButton;
